import React, { useMemo } from 'react'
import { Box, CheckBox, Text } from '@usap/uicomponents'
import seoIds from '../../../../config/seoIds'

export default function RefineList({
  refinementSubList,
  refineItem,
  maxShow,
  data,
  getHasChecked,
  handleCheckBoxChange,
  parent,
  label,
}) {
  const styleMemo = useMemo(() => ({
    wrapperBoxMargin: { top: 'small' },
    wrapperBoxPad: { vertical: 'small' },
    wrapperBoxStyle: { minHeight: 'unset' },
    textMargin: { right: 'xsmall' },
  }), [])

  return refinementSubList.map(({ text: refName, numRec, link }, index) => {
    const showAll = index < maxShow || !label
    const isChecked = getHasChecked(data, refName)
    const refineSubItemName = refName.replace(/[ ,]+/g, '-')

    const replacedRefineSubItemName = `${refineSubItemName.replace(' ', '').toString().toLowerCase()}`
    const toReplaceKey = `${refineItem}-${replacedRefineSubItemName}-${index}`
    const mapKey = seoIds.refineSubItem.replace('{{key}}', toReplaceKey)

    return (
      showAll && (
        <Box
          key={mapKey}
          id={mapKey}
          margin={styleMemo.wrapperBoxMargin}
          pad={styleMemo.wrapperBoxPad}
          style={styleMemo.wrapperBoxStyle}
        >
          <CheckBox
            checked={isChecked}
            label={(
              <>
                <Text size="small" margin={styleMemo.textMargin}>
                  {refName}
                  <Text size="small" color="greyText">
                    {` (${numRec})`}
                  </Text>
                </Text>
              </>
                )}
            onChange={() => handleCheckBoxChange(isChecked, parent, refName, link)}
          />
        </Box>
      )
    )
  })
}
